import React from "react";
import EyeIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { TableCell, TableRow } from "@mui/material";
import IconButtonIcons from "../../Common/IconButtonIcons";
import DeleteIcon from "@mui/icons-material/DeleteForever";
import TableCommon from "../../Common/Table";
import { handleDateTimeDefault } from "../../../helpers/utils";
import { baseUrl } from "../../../helpers/constants";
import { isAuth } from "../../../helpers/cookies";
import { useDeleteCandidateMutation } from "../../../store/candidate/candidateApis";

const CandidateTableComponent = ({ loading, fetching = false, count, data, edit, pagination, handlePagination }) => {
    const [handleDelete] = useDeleteCandidateMutation();
    let columns = [
        {
            title: "Sr. No.",
            sort: false
        },
        {
            title: "Sanstha",
            sort: false,
            minWidth: 170,
            hide: (isAuth().roles !== "admin")
        },
        {
            title: "Name",
            field: "name",
            sort: true
        },
        {
            title: "Mobile",
            field: "mobile",
            sort: true
        },
        {
            title: "Photo",
            field: "profile",
            sort: false,
            minWidth: 50,
        },
        {
            title: "Created At",
            field: "createdAt",
            sort: true,
            hide: (isAuth().roles !== "admin")
        },
        {
            title: "Action",
            name: "",
            sort: false
        },
    ];

    const deleteManage = (_id) => {
        if (window.confirm("Are you sure you want to delete?")) {
            handleDelete({ _id });
        }
    }

    const renderTableData = !loading && data && data.length > 0 ? (
        data.map(function (row, index) {
            return (
                <TableRow
                    key={index}
                    sx={{ "td, th": { border: 0, padding: "10px" } }}
                >
                    <TableCell align="center">{(index + 1) + (pagination.pageNo * pagination.limit)}</TableCell>
                    {isAuth().roles === "admin" ? <TableCell align="center">{row?.sanstha_id?.name || "-"}</TableCell> : null}
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{row?.mobile}</TableCell>
                    <TableCell align="center">
                        <img src={baseUrl + "/" + ((row.profile.length > 0 && row.profile[0]) || "public/no-image.png")} alt="Profile" width={50} />
                    </TableCell>
                    {isAuth().roles === "admin" ? <TableCell align="center">{handleDateTimeDefault(row?.createdAt)}</TableCell> : null}
                    <TableCell align="center" component="th" scope="row">
                        <IconButtonIcons
                            title="Edit"
                            IconComponent={EditIcon}
                            color="info"
                            onClick={() => edit(row, "Edit")}
                        />
                        <IconButtonIcons
                            title="View"
                            IconComponent={EyeIcon}
                            color="info"
                            onClick={() => edit(row, "View")}
                        />
                        {
                            (isAuth().roles === "admin" || isAuth().roles === "sanstha")
                                ?
                                <IconButtonIcons
                                    title="Delete"
                                    IconComponent={DeleteIcon}
                                    color="info"
                                    onClick={() => deleteManage(row._id)}
                                />
                                :
                                null
                        }
                    </TableCell>
                </TableRow>
            )
        })
    ) : (
        <TableRow sx={{ "td, th": { border: 0, padding: "10px" } }}>
            <TableCell colSpan={7} align="center">Data not found</TableCell>
        </TableRow>
    );

    return (
        <TableCommon columns={columns} tableData={renderTableData} count={count} loading={loading || fetching} pagination={pagination} handlePagination={handlePagination} />
    )
}

export default CandidateTableComponent;